import { Trans, useLingui } from "@lingui/react/macro";
import React from "react";
import {
  Button,
  HorizontalSuiteCard,
  HorizontalSuiteCardProps,
  Price
} from "@silversea-ssc/ui-components-react";

import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";
import { buttonVariantForRequestAQuote } from "src/utils/cruise";
import { NewEcommerceButton } from "components/ECommerceButtons";
import { isSuitePriceWaitlist } from "src/utils/suites";

interface CruiseSuiteCardProps
  extends Omit<
    HorizontalSuiteCardProps,
    | "prices"
    | "actionButton"
    | "detailsButton"
    | "pricesDisclaimer"
    | "featuresSectionTitle"
  > {
  prices: Price[];
  detailsOnClick: () => void;
  trackingName: string;
  ecommerceStatus?: ECommerceStatus;
  raqCTAUrl: string | undefined;
  isCruiseWaitlist: boolean;
  features: string[];
}

const HorizontalCruiseSuiteCard: React.FC<
  React.PropsWithChildren<CruiseSuiteCardProps>
> = ({
  prices,
  ecommerceStatus,
  detailsOnClick,
  raqCTAUrl,
  isCruiseWaitlist,
  features,
  ...props
}) => {
  const { t } = useLingui();
  const isWaitlist = isSuitePriceWaitlist(prices);

  return (
    <HorizontalSuiteCard
      {...props}
      features={features}
      prices={prices}
      pricesDisclaimer={t`Prices per guest start from`}
      featuresSectionTitle={t`Category Highlights`}
      actionButton={
        <NewEcommerceButton
          raqUrl={raqCTAUrl}
          url={isWaitlist ? { type: "disabled" } : ecommerceStatus}
          variant={buttonVariantForRequestAQuote(
            ecommerceStatus,
            isCruiseWaitlist,
            isWaitlist
          )}
          size="regular"
          overrideEcommerceLabel={<Trans>Book your suite</Trans>}
        />
      }
      detailsButton={
        <Button
          variant="inline-text"
          renderAs="button"
          onClick={detailsOnClick}
          dataContentPiece="details"
          style={{ textAlign: "left" }}
        >
          <Trans>Category Details</Trans>
        </Button>
      }
    />
  );
};

export default HorizontalCruiseSuiteCard;
